import * as RehabDeviceI from "./RehabDevice";
import * as RehabWorkListI from "./RehabWorkList";

const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  RehabDevice: {
    default: {
      Action: RehabDeviceI.Action,
      START: RehabDeviceI.Start,
    },
  },
  RehabWorkList: {
    default: {
      Action: RehabWorkListI.Action,
      START: RehabWorkListI.Start,
    },
  },
};

export default SequencePattern;
